import { createTheme } from "@mui/material"
import { hover } from "@testing-library/user-event/dist/hover"
import { Colors, Fonts } from "../utils/constants"

export const fullHeight = {
    height: '100%',
}

export const blueBg = {
    backgroundColor: Colors.blue
}

export const center = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}

export const spaceEvenly = {
    display: 'flex',
    justifyContent: 'space-evenly'
}

export const width50 = {
    width: '50%'
}

export const flexColumn = {
    flexDirection: 'column' as 'column'
}

export const commonMUITheme = createTheme({
    palette:{
        mode:'dark',
        primary : {
            main: 'rgb(255, 199, 44)',       
        },
    },
    components: {
        //Name of the component
        MuiFormControl: {
            styleOverrides: {
                root: {
                    borderColor: 'rgba(255, 255, 255, 0.8)',
                    color: 'rgba(255, 255, 255, 0.8)'
                }
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: 'rgba(255, 255, 255, 0.8)',
                },
                root: {
                    fontFamily: Fonts.sspMedium,
                }
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    paddingLeft: 25,
                    borderColor: 'rgba(255, 255, 255, 0.8)',
                    
                }
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'white',
                    fontFamily: Fonts.sspMedium,
                }
            },
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    backgroundColor: Colors.blue,
                },
                
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: Colors.blue,
                },
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    border: 10,
                    borderColor: 'red',
                    width: 'fit-content'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: "black",
                    backgroundColor: "rgba(204, 204, 204, 1)"
                }
            }
        },
    },
});
